import type { MedplumClient } from '@medplum/core'
import UTIF from 'utif'
import { logError } from '@/utils/errorUtils'
import { downloadAttachment } from '@/utils/downloadAttachment.ts'

export async function tiffToURL(
  medplum: MedplumClient,
  url: string,
  mime: 'image/png' | 'image/jpeg' = 'image/png',
  quality?: number,
): Promise<string[]> {
  try {
    const blob = await downloadAttachment(medplum, url)
    const buf = await blob.arrayBuffer()

    const ifds = UTIF.decode(buf)

    const urls: string[] = []

    for (const ifd of ifds) {
      UTIF.decodeImage(buf, ifd)
      const rgba = UTIF.toRGBA8(ifd)

      const canvas = document.createElement('canvas')
      canvas.width = ifd.width
      canvas.height = ifd.height

      const ctx = canvas.getContext('2d')!

      const imageData = new ImageData(new Uint8ClampedArray(rgba), ifd.width, ifd.height)

      ctx.putImageData(imageData, 0, 0)

      const blob: Blob = await new Promise((resolve) =>
        canvas.toBlob((b) => resolve(b!), mime, quality),
      )
      urls.push(URL.createObjectURL(blob))
    }
    return urls
  } catch (error) {
    logError('tiff-conversion', 'Error with UTIF', error)
    throw error
  }
}
